<template>
  <router-link to="/" class="link-back">&larr; Home</router-link>
  <h2>This is the gate orders page</h2>
  <button
    v-for="gate in gates"
    :key="gate.gate"
    @click="showGate(gate.gate)"
  >
    Gate {{ gate.gate }}
  </button>
  <div v-for="gate in gates" :key="gate.gate">
    <gate-order v-if="activeGate === gate.gate" :gate="gate.gate"></gate-order>
  </div>
</template>

<script>
export default {
  inject: ['gateData'],
  data() {
    return {
      gates: this.gateData,
      activeGate: this.gateData[0].gate
    }
  },
  methods: {
    showGate(gateNum) {
      this.activeGate = gateNum;
    }
  }
}
</script>